/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";
import baustein from "baustein";
import analytics from "analytics/analytics";
import environment from "modules/environment";
import globals from "modules/globals";
import userProfiler from "modules/userprofiler";
import { gettext } from "modules/django-i18n";
import browser from "../utils/browser";
import cookie from "../utils/cookie";

const hiddenClass = "chrome-notification-consent--hidden";
const consentCookieName = "notificationConsent";
const consentCookiePeriod = 365;

export default baustein.register("chrome-notification-consent", {
    setupEvents(add) {
        add("click", ".chrome-notification-consent__button--no", this._noClick);
        add("click", ".chrome-notification-consent__button--yes", this._yesClick);
        this.setGlobalHandler("resize", this._onResize);
    },

    tagName: "div",

    template() {
        return `
            <div is="chrome-notification-consent" class="chrome-notification-consent chrome-notification-consent--hidden">
                <p class="chrome-notification-consent__content heading-5">
                    ${gettext("enable_browser_notifications.title")}
                </p>
                <div class="chrome-notification-consent__buttons">
                    <div class="btn btn-primary chrome-notification-consent__button chrome-notification-consent__button--yes">
                        ${gettext("enable_browser_notifications.yes_btn_text")}
                    </div>
                    <div class="btn btn-primary chrome-notification-consent__button chrome-notification-consent__button--no">
                        ${gettext("enable_browser_notifications.no_btn_text")}
                    </div>
                </div>
            </div>
        `;
    },

    init() {
        this.firstTimeLoggedIn = userProfiler.isFirstTimeLoggedIn();
        this.heimdallEnabled = environment.get("chromeNotificationConsentTest");
        this.isChrome = browser.chrome;
    },

    onInsert() {
        // we only want to show the template on desktop, otherwise we want it to be hidden
        const isDesktop = browser.getViewport() >= browser.VIEWPORTS.DESKTOP;
        if (
            isDesktop &&
            !this.hasConsentCookie() &&
            this.firstTimeLoggedIn &&
            this.heimdallEnabled &&
            this.isChrome
        ) {
            this._showPrompt();
        }
    },

    _onResize: _.throttle(function() {
        const isDesktop = browser.getViewport() >= browser.VIEWPORTS.DESKTOP;
        if (
            isDesktop &&
            !this.hasConsentCookie() &&
            this.firstTimeLoggedIn &&
            this.heimdallEnabled &&
            this.isChrome
        ) {
            if (this.el.classList.contains(hiddenClass)) {
                this._showPrompt();
            }
        } else {
            this.el.classList.add(hiddenClass);
        }
    }, 250),

    _yesClick() {
        analytics.event("Chrome notification test", "Accepted");
        this.setConsentCookie();
        this.destroy();
    },

    _noClick() {
        analytics.event("Chrome notification test", "Rejected");
        this.setConsentCookie();
        this.destroy();
    },

    _showPrompt() {
        this.el.classList.remove(hiddenClass);
        analytics.event("Chrome notification test", "Saw");
    },

    hasConsentCookie() {
        return Boolean(cookie(consentCookieName));
    },

    setConsentCookie() {
        cookie(consentCookieName, 1, {
            expires: consentCookiePeriod,
            path: "/",
            withEncoding: false,
            domain: this.getCookieDomain()
        });
    },

    getCookieDomain() {
        let hostnameParts = globals.window.location.hostname.split(".");

        if (hostnameParts.includes("www") || hostnameParts.includes("checkout")) {
            return hostnameParts.slice(1).join(".");
        }
    }
});

